import { extractInfo } from "../form";

const defaultDesc = crm => async info => {
	const { ownValue, subValue, updateValue } = extractInfo(info);
    if (!ownValue) {
        updateValue(subValue);
    }
};

export default defaultDesc;